import { FC } from "react";
import React from "react";

import { ListNotification, ListNotificationItem } from "@/components";
import "@/components/Loader/Loader";
import type { Notification } from "@/types/notification";
import { formatNotificationDate } from "@/utils/formatter";

type Props = {
  notices: Notification[];
  detailUrl: (id: number) => string;
};

export const NotificationList: FC<Props> = (props) => {
  const { notices, detailUrl } = props;

  return (
    <>
      {notices.map((value, index) => {
        return (
          <React.Fragment key={index}>
            <ListNotification>
              <ListNotificationItem
                status={value.flagType}
                date={formatNotificationDate(value.postedAt)}
                label={value.title}
                to={detailUrl(value.id)}
                notification={value}
              />
            </ListNotification>
          </React.Fragment>
        );
      })}
    </>
  );
};
